const DERIVED_EQUIPMENT_TYPES = ['Ammunition', 'Melee Weapon', 'Ranged Weapon', 'Armour']

export function getNormalisedEquipmentType(rawEquipmentType) {
  if (typeof rawEquipmentType === 'string') {
    const trimmed = rawEquipmentType.trim()
    return trimmed || 'n/a'
  }

  return rawEquipmentType == null ? 'n/a' : rawEquipmentType
}

export function getArtefactBaseItem(staticItem, getStaticItemById) {
  const baseItemId = staticItem?.artefact_base_item ?? null

  if (!baseItemId || typeof getStaticItemById !== 'function') {
    return null
  }

  return getStaticItemById(baseItemId) ?? null
}

export function getEffectiveItemType(staticItem, getStaticItemById) {
  if (!staticItem) return ''

  if (staticItem.type !== 'Artefact') {
    return staticItem.type ?? ''
  }

  const baseItem = getArtefactBaseItem(staticItem, getStaticItemById)
  const baseType = baseItem?.type ?? ''

  if (DERIVED_EQUIPMENT_TYPES.includes(baseType)) {
    return baseType
  }

  return staticItem.type ?? ''
}

export function getItemPropertySource(staticItem, getStaticItemById) {
  if (!staticItem) return null

  const effectiveType = getEffectiveItemType(staticItem, getStaticItemById)
  if (!DERIVED_EQUIPMENT_TYPES.includes(effectiveType)) {
    return staticItem
  }

  return getArtefactBaseItem(staticItem, getStaticItemById) ?? staticItem
}
